import { render, staticRenderFns } from "./Billing_details.vue?vue&type=template&id=bfdc819a"
import script from "./Billing_details.vue?vue&type=script&lang=js"
export * from "./Billing_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports